import icon from '@/presentation/assets/images/icons/design-fto-search.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest';

export const DESIGN_FTO_ROUTER_NAME = 'design-fto';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: DESIGN_FTO_ROUTER_NAME,
    exclusiveRoutePath: '/design-fto',
    getComponent: () => {
        return import('./DesignFtoLayout.vue');
    },
};

const toolConfig: ToolConfig = {
    tabIndex: 3,
    label: 'drafting.design-fto',
    icon,
    aclCheckPath: (permission) => true,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到外观防侵权检索页面
         * @param commandId - 命令(去到外观防侵权检索页面)
         * @param params - 参数
         */
        executeCommand(commandId: 'command:route:design-fto', params?: CustomQueryParams): void;
    }
}
